import { ScrollView } from '@unistocks/components/basic/scrollview';
import { getAssetDetailsHref } from '@unistocks/features/assets/asset-routes';
import { getCalculatedValueAssetId } from '@unistocks/features/dashboard/components/calculated-value/asset-id';
import { EventViewItemProps } from '@unistocks/features/dashboard/components/dashboard-data/event-view/layouts/event-view-item-props';
import {
  DashboardItemFrame,
  DashboardItemProps
} from '@unistocks/features/dashboard/components/dashboard-item/dashboard-item';
import { DashboardItemHeader } from '@unistocks/features/dashboard/components/dashboard-item/dashboard-item-header';
import { ValueListRow } from '@unistocks/features/dashboard/components/value-list-item/value-list-row';
import { ValueListTable } from '@unistocks/features/dashboard/components/value-list-table/value-list-table';
import { useDashboardGetEventViewDataQuery } from '@unistocks/proxy/axios-client/DashboardQuery';
import { useRouter } from 'expo-router';

export const EventViewList = ({ item, openSettings, ...frameProps }: DashboardItemProps) => {
  const router = useRouter();
  const { id, settings } = item;
  const title = settings.title?.trim();
  const listValues = settings.values!;

  return (
    <DashboardItemFrame {...frameProps}>
      <DashboardItemHeader item={item} title={title} openSettings={openSettings} />
      <ScrollView showsVerticalScrollIndicator={false} $platform-web={{ h: '80%' }}>
        <ValueListTable
          firstList={listValues}
          getRowOnPress={value => {
            const assetId = getCalculatedValueAssetId(value);

            return assetId ? () => router.push(getAssetDetailsHref(assetId)) : undefined;
          }}
          renderRow={(value, index) => (
            <EventViewTableRow dashboardItemId={id} value={value} index={index} />
          )}
        />
      </ScrollView>
    </DashboardItemFrame>
  );
};

export const EventViewTableRow: React.FC<EventViewItemProps> = ({
  dashboardItemId,
  value,
  index
}) => {
  const { data, isPending, isStale, isError } = useDashboardGetEventViewDataQuery({
    id: dashboardItemId,
    index
  });

  return (
    <ValueListRow
      calculatedValue={data}
      label={value.displayName!}
      isLoading={isPending}
      isStale={isStale}
      isError={isError}
    />
  );
};

EventViewTableRow.displayName = 'EventViewTableRow';
